// extracted by mini-css-extract-plugin
export default {"privacy":"privacy_privacy__FfG3j","privacyHeading":"privacy_privacyHeading__LFFz+","privacyBox":"privacy_privacyBox__0E4Mh"};